import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MyProfileComponent } from './my-profile.component';
import { AuthGuard } from '../shared/guards/auth.guard';
import { TermsGuard } from '../shared/guards/terms.guard';
import { LoansGuard } from '../shared/guards/loans.guard';

const routes: Routes = [
  { path: 'my-profile',
    component: MyProfileComponent,
    children: [],
    canActivate: [AuthGuard, TermsGuard, LoansGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MyProfileRoutingModule { }
